<template>
  <div id="details-container">
    <LazyHH4 class="mt-5 mb-4">
      Détails du bien
    </LazyHH4>
    <div class="container">
      <div
        v-if="show"
        class="row"
      >
        <div
          v-if="propertyData?.construction?.construction_year"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Année de construction</span>
            </div>
            <div class="col-5 value">
              <span>{{ propertyData?.construction?.construction_year }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="propertyData?.area?.value"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Surface Carrez</span>
            </div>
            <div class="col-5 value">
              <span>{{ Math.round(propertyData?.area?.value) }} m²</span>
            </div>
          </div>
        </div>

        <div
          v-if="propertyData?.lead?.estate?.characteristic?.total_land_area_m2"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Surface du terrain</span>
            </div>
            <div class="col-5 value">
              <span>{{ propertyData?.lead?.estate?.characteristic?.total_land_area_m2 }} m²</span>
            </div>
          </div>
        </div>

        <div
          v-if="objAsList(propertyData?.heating)"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Chauffage</span>
            </div>
            <div class="col-5 value">
              <span>{{ objAsList(propertyData?.heating) }} </span>
            </div>
          </div>
        </div>

        <div
          v-if="objAsList(propertyData?.water)"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Eau chaude</span>
            </div>
            <div class="col-5 value">
              <span>{{ objAsList(propertyData?.water) }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="propertyData?.heating_energy_comment"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Chauffage</span>
            </div>
            <div class="col-5 value">
              <span>{{ propertyData?.heating_energy_comment }} </span>
            </div>
          </div>
        </div>

        <div
          v-if="propertyData?.hot_water_energy_comment"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Eau chaude</span>
            </div>
            <div class="col-5 value">
              <span>{{ propertyData?.hot_water_energy_comment }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="propertyData?.floor?.type"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Etage</span>
            </div>
            <div class="col-5 value">
              <span>{{ propertyData?.floor?.type }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="arrAsList(propertyData?.orientations)"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Exposition</span>
            </div>
            <div class="col-5 value">
              <span>{{ arrAsList(propertyData?.orientations) }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="propertyData?.view?.landscape?.length && arrAsList(propertyData?.view?.landscape)"
          class="col-12 detail"
        >
          <div class="row">
            <div class="col-7 label">
              <span>Vue</span>
            </div>
            <div class="col-5 value">
              <span v-if="propertyData?.view?.type != null">{{ propertyData?.view?.type }},&nbsp;</span>
              <span>{{ arrAsList(propertyData?.view?.landscape) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  propertyData?: Record<string, any>
}>()

const show = ref(true)

function objAsList (obj: any) {
  let list = ''
  Object.keys(obj).forEach(function (key) {
    if (obj[key]) {
      list += obj[key] + ', '
    }
  })

  if (list.length > 0) { list = list.substring(0, list.length - 2) }

  return list
}

function arrAsList (arr: any) {
  let list = ''
  arr.forEach(function (val: any) {
    if (val) {
      list += val + ', '
    }
  })

  if (list.length > 0) { list = list.substring(0, list.length - 2) }

  return list
}

</script>

<style lang="scss" scoped>
#details-container {
  margin-bottom: 30px;
}

.label {
  color: $night-blue;
  padding-left: 0;
}

.detail {
  border-bottom: 1px solid #CECFD6;
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.detail .label {
  font-weight: bold;
}

.detail .value {
  text-align: right;
}

.toggle {
  float: right;
}
</style>
